import { render, staticRenderFns } from "./ProposalPage.vue?vue&type=template&id=07c7e93c&scoped=true"
import script from "./ProposalPage.vue?vue&type=script&lang=js"
export * from "./ProposalPage.vue?vue&type=script&lang=js"
import style0 from "./ProposalPage.vue?vue&type=style&index=0&id=07c7e93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c7e93c",
  null
  
)

export default component.exports